const pendingRoutePlugin = async app => {
    app.get('/pending.gif', { schema: { hide: true } }, () => new Promise(() => {}));
};

module.exports = {
    pendingRoutePlugin
};
